module.exports = __webpack_public_path__ + "img/item06.bc593fbd.png";